import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
    mainCard: {
        marginBottom: "50px",
        marginTop: "50px"
    },

    null: {
        margin: "30px 20px"
    }
});

export default useStyles;